import { render } from "./MenuCabeceraEs.vue?vue&type=template&id=88f28b7c&scoped=true"
import script from "./MenuCabeceraEs.vue?vue&type=script&lang=js"
export * from "./MenuCabeceraEs.vue?vue&type=script&lang=js"

import "./MenuCabeceraEs.vue?vue&type=style&index=0&id=88f28b7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88f28b7c"]])

export default __exports__